// extracted by mini-css-extract-plugin
export var root = "RegisterNow-module--root--+TYNm";
export var txt = "RegisterNow-module--txt--lX8xE";